import React, { memo } from "react";
import { useTranslation } from "react-i18next";

import { PRIVACY_TYPOGRAPHY } from "../../constants/privacyConstants";
import { useTheme } from "../../hooks/useTheme";
import withTranslationGuard from "../common/withTranslationGuard";

import PrivacyBaseSection from "./PrivacyBaseSection";


const PrivacyChildrenPrivacySection: React.FC = () => {
  const { themeClasses } = useTheme();
  const { t } = useTranslation('privacy');

  return (
    <PrivacyBaseSection 
      hasBackground={false} 
      sectionId="children-privacy" 
      ariaLabel="Children's privacy policy"
    >
      <h2 className={`${PRIVACY_TYPOGRAPHY.h2} ${themeClasses.text}`}>
        {t('sections.rights.children_privacy.title')}
      </h2>
      <p className={`${PRIVACY_TYPOGRAPHY.paragraph} ${themeClasses.text}`}>
        {t('sections.rights.children_privacy.description')}
      </p>
    </PrivacyBaseSection>
  );
};

export default withTranslationGuard(['privacy'])(memo(PrivacyChildrenPrivacySection)); 